import { NgModule } from '@angular/core'
import { DisplayMultipleNamesPipe } from './display-multiple-names.pipe'

@NgModule({
    declarations: [DisplayMultipleNamesPipe],
    exports: [DisplayMultipleNamesPipe],
    providers: [DisplayMultipleNamesPipe],
})
export class DisplayMultipleNamesModule {
}